import React, { useEffect, useState } from 'react';
import { useUserContext } from '../context/UserContext';
import { useHistory } from 'react-router-dom';
import { APP_USER_ROLE } from '../constants/UserRoles';
import { LoaderContent } from 'engage/components/LoaderContent/LoaderContent';

export const withUserRoleCheck = Component => {
  return props => {
    const [init, setInit] = useState(false);

    const { userRole } = useUserContext();

    const history = useHistory();

    useEffect(() => {
      if (userRole) {
        if (!(userRole === APP_USER_ROLE.MANAGER.TYPE || userRole === APP_USER_ROLE.SUPER_ADMIN.TYPE)) {
          history.push('/eg/home');
        } else {
          setInit(true);
        }
      }
    }, [userRole]);

    if (!init) {
      return <LoaderContent />;
    }

    return <Component {...props} />;
  };
};
